<template>
<div>
  <v-progress-linear v-show="load" :indeterminate="true" />

  <v-main class="py-2 px-2">
    <!-- *************DADOS GERAIS DA UNIDADE********************** -->
    <v-layout row wrap class="mb-2 mx-2">
      <v-flex xs12 md12>
        <v-layout row wrap>
          <v-flex xs12 sm6 >
            <v-card outlined class="rounded-xl">
              <v-toolbar dense elevation="1">
                <v-toolbar-title class="pa-0">
                  <span class="subheading pa-0">Tempo médio de espera até a recepcionista: </span>
                </v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text class=" pt-0">
                <span class="display-1 font-weight-light">{{ esperaDiaRecep.mediaTempoEspera }}</span> (min)
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 class="pl-1">
            <v-card outlined class="rounded-xl">
              <v-toolbar flat elevation="1" dense>
                <v-toolbar-title class="pa-0">
                  <span class="subheading pa-0">Tempo médio dos atendimentos da recepcionista: </span>
                </v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text class=" pt-0">
                <span class="display-1 font-weight-light">{{ esperaDiaRecep.mediaAtendimentoRecepcionista }}</span> (min)
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs12 sm6 class="pl-1  pt-1">
            <v-card class="rounded-xl" outlined>
              <v-toolbar elevation="1" dense >
                <v-toolbar-title class="pa-0">
                  <span class="subheading pa-0">Quantidade de atendimentos: </span>
                </v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text class=" pt-0">
                <span class="display-1 font-weight-light">{{ quantAtendimentos }}</span>
              </v-card-text>
            </v-card>
          </v-flex>
            <v-flex xs12 sm6 class="pl-1  pt-1">
            <v-card class="rounded-xl" outlined>
              <v-toolbar elevation="1" dense >
                <v-toolbar-title class="pa-0">
                  <span class="subheading pa-0">Tempo médio do paciente na unidade:</span>
                </v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text class=" pt-0">
                <span class="display-1 font-weight-light">{{ esperaDiaRecep.mediaTempoTotal }}</span>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12 md12>
        <v-card  outlined class="rounded-xl">
          <v-card-title class="font-weight-bold">
            Tempo médio por dia
            <v-spacer />
            <v-text-field v-model="search2" append-icon="search" label="Buscar" single-line hide-details />
          </v-card-title>
          <v-data-table :headers="headers2" :items="listaTabela2" :loading="loadingTabela2" items-per-page-text="Linhas por página" no-data-text="Nenhum item disponível para o intervalo buscado" :search="search2">
            <template v-slot:items="props">
              <td>{{ props.item.mes }}</td>
              <td class="text-xs-center">
                {{ converterDate(props.item.data) }}
              </td>
              <td class="text-xs-center">
                {{ props.item.tempoEspera }}
              </td>
              <td class="text-xs-center">
                {{ props.item.quantAtendimentos }}
              </td>
            </template>
            <template v-slot:no-results>
              <v-alert :value="true" color="error" icon="warning">
                Sua busca por "{{ search2 }}" não encontrou
                resultados.
              </v-alert>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- ***************************TABELA************************ -->
    <v-layout row wrap />
  </v-main>
</div>
</template>

<script>
import administradorUnidadeService from './../../../services/administradorUnidade.service'
import moment from 'moment'
// import { EventBus } from './../../../main'

export default {
  name: 'FuncionariosOnline',
  components: {},
  props: {
    tempoEsperaPaciente: {
      type: String,
      default: '00:00:00'
    },
    esperaPacienteRecep: Object,
    esperaDiaRecep: Object,
    tempoMedioUnidade: {
      type: String,
      default: '00:00:00'
    }
  },
  data: (vm) => ({
    tab: null,
    valid: true,
    quantAtendimentos: 0,
    mediaAtendimentoUnidade: 0,
    tempoEspera: 0,
    loadingTabela1: false,
    loadingTabela2: false,
    load: 0,
    menu1: false,
    menu2: false,
    search1: '',
    mediaAtendimentoPaciente: '00:00:00',
    search2: '',
    listaFuncionariosTabela: [],
    headers2: [
      {
        text: 'Data',
        align: 'center',
        value: 'data'
      },
      {
        text: 'Quantidade de atendimentos',
        align: 'center',
        value: 'quantAtendimentos'
      },
      {
        text: 'Tempo médio de espera',
        align: 'center',
        value: 'mediaTempoEsperaDia'
      },
      {
        text: 'Tempo médio de atendimento da recepcionista',
        align: 'center',
        value: 'mediaAtendimentoRecepcionistaDia'
      },
      {
        text: 'Tempo médio do paciente na unidade',
        align: 'center',
        value: 'mediaTempoTotalDia'
      }
    ],
    listaTabela2: [{
      data: '---',
      mediaTempoEsperaDia: '---',
      mediaAtendimentoRecepcionistaDia: '---',
      mediaTempoTotalDia: '---',
      quantAtendimentos: '---',
      tempoEspera: '---'
    },
    {
      data: '---',
      mediaTempoEsperaDia: '---',
      mediaAtendimentoRecepcionistaDia: '---',
      mediaTempoTotalDia: '---',
      quantAtendimentos: '---',
      tempoEspera: '---'
    }
    ]
  }),

  computed: {
    computedDateFormatted1 () {
      return this.formatDate(this.date1)
    },
    computedDateFormatted2 () {
      return this.formatDate(this.date2)
    }
  },
  watch: {
    esperaPacienteRecep: function () {
      this.tempoEsperaPacienteRecep()
    },
    esperaDiaRecep: function () {
      this.tempoEsperaPacienteRecep()
    }
  },

  mounted () {
    // EventBus.$on('carregarDados', this.carregarDadosTabelas)
    // EventBus.$on('carregarMediaAtendimentos', this.carregarMediaAtendimentos)
    // this.tempoAtendimentoRecep()
    if (this.esperaPacienteRecep != null) {
      this.carregarDadosTabelas()
    }
    // this.tempoEsperaDiaRecep()
  },

  created () {
    console.log('created...')
  },

  methods: {
    formatDate (date) {
      if (date == null || date === '') {
        return ''
      } else {
        return moment(date).format('DD/MM/YYYY hh:mm:ss')
      }
    },
    tempoEsperaDiaRecep () {
      // console.log('----222----')
      console.log(this.esperaDiaRecep)
      this.esperaDiaRecep.list.forEach((element) => {
        var data = element.data
        if (data) {
          element.data = this.formatDate(data)
        }
      })
      // this.mediaAtendimentoPaciente = this.esperaDiaRecep.mediaAtendimento
      this.listaTabela2 = this.esperaDiaRecep.list
    },
    converterDate (data) {
      if (data == '---') {
        return '---'
      } else {
        var d = new Date(data)
        var dia = d.getDate().toString()
        var diaF = dia.length == 1 ? '0' + dia : dia
        var mes = (d.getMonth() + 1).toString() // +1 pois no getMonth Janeiro começa com zero.
        var mesF = mes.length == 1 ? '0' + mes : mes
        var anoF = d.getFullYear()

        return diaF + '/' + mesF + '/' + anoF
      }
    },
    formatarTempo (tempo) {
      var a = tempo.split(':')
      var text = ''
      if (a[0] != '00') {
        text = a[0] + ' hr' + text
      }
      if (a[1] != '00') {
        text = a[1] + ' min' + text
      }
      if (a[2] != '00') {
        text = a[2] + ' sg' + text
      }
      return text
    },

    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    carregarDadosTabelas (date1, date2) {
      console.log('Carregar dados Unidade')
      this.tempoEsperaPacienteRecep(date1, date2) // esse so manda um dado
      this.tempoEsperaDiaRecep(date1, date2)
    },
    carregarMediaAtendimentos (mediaAtendimentoUnidade) {
      this.mediaAtendimentoUnidade = mediaAtendimentoUnidade
    },

    calculaMediaAtendimentoUnidade (lista) {
      if (!lista.length) {
        return 0
      }
      var produto = 0
      var somaAtendimentos = 0
      lista.forEach((element) => {
        somaAtendimentos = somaAtendimentos + element.quantAtendimentos
        var hms = element.mediaAtendimento // your input string
        var a = hms.split(':') // split it at the colons
        var seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2]
        var newSeconds = element.quantAtendimentos * seconds
        produto = produto + newSeconds
      })
      var result = produto / somaAtendimentos
      var date = new Date(result * 1000)
      var hh = date.getUTCHours()
      var mm = date.getUTCMinutes()
      var ss = date.getSeconds()
      // If you were building a timestamp instead of a duration, you would uncomment the following line to get 12-hour (not 24) time
      // if (hh > 12) {hh = hh % 12;}
      // These lines ensure you have two-digits
      if (hh < 10) {
        hh = '0' + hh
      }
      if (mm < 10) {
        mm = '0' + mm
      }
      if (ss < 10) {
        ss = '0' + ss
      }
      // This formats your string to HH:MM:SS
      var t = hh + ':' + mm + ':' + ss
      return t
    },

    tempoAtendimentoRecep_ () {
      this.load = this.load + 1
      administradorUnidadeService.administradorUnidade
        .tempoAtendimentoRecep(this.date1, this.date2)
        .then((rsp) => {
          console.log('rsp tempoAtendimentoRecep:', rsp.data)
          this.listaTabela1 = rsp.data
          this.mediaAtendimentoUnidade = this.mediaAtendimentos
          //  rsp.data
          // )
        }).finally(() => {
          this.load = this.load - 1
        })
        .catch((err) => {
          // handle your error
          this.loadingTabela1 = false
          console.log(err)
        })
    },

    tempoEsperaPacienteRecep () {
      this.quantAtendimentos = this.esperaPacienteRecep.quantAtendimentos
      this.tempoEspera = this.esperaPacienteRecep.tempoAtendimentoRecep
      this.mediaAtendimentoUnidade = this.esperaPacienteRecep.mediaAtendimentoUnidade
    }
  }

  /* tempoEsperaPacienteRecep_ (date1, date2) {
    // essa n precisa de tabela
    this.load = this.load + 1
    administradorUnidadeService.administradorUnidade
      .tempoEsperaPacienteRecep(date1, date2)
      .then((rsp) => {
        console.log('rsp tempoEsperaPacienteRecep:', rsp.data)
        if (rsp.data !== 'false') {
          this.quantAtendimentos = rsp.data.quantAtendimentos
          this.tempoEspera = rsp.data.tempoEspera
          this.mediaAtendimentoUnidade = rsp.data.tempoTotal
          // EventBus.$emit('carregarTempoEspera', this.tempoEspera)
        }
      })
      .finally(() => {
        this.load = this.load - 1
      })
      .catch((err) => {
        // handle your error here
        console.log(err)
      })
  }, */

  /* tempoEsperaDiaRecep_ (date1, date2) {
    this.loadingTabela2 = true
    this.load = this.load + 1
    administradorUnidadeService.administradorUnidade
      .tempoEsperaDiaRecep(date1, date2)
      .then((rsp) => {
        console.log('rsp tempoEsperaDiaRecep:', rsp.data)
        rsp.data.list.forEach((element) => {
          var data = new Date(element.data)
          element.mes = data.getMonth() + 1
        })
        this.mediaAtendimentoPaciente = rsp.data.mediaAtendimento
        this.listaTabela2 = rsp.data.list
        this.loadingTabela2 = false
      })
      .finally(() => {
        this.load = this.load - 1
      })
      .catch((err) => {
        // handle your error here
        this.loadingTabela2 = false
        console.log(err)
      })
  } */

}
</script>

<style scoped>
.md-card {
  width: 320px;
  margin: 4px;
  display: inline-block;
  vertical-align: top;
}

.feedback {
  background-color: #31b0d5;
  color: white;
  padding: 10px 20px;
  border-radius: 4px;
  border-color: #46b8da;
}

#mybutton {
  position: fixed;
  bottom: 20px;
  right: 10px;
}

.input-qty {
  width: 60px;
  height: 25px;
  border: 2px solid #80cbc4;
  border-radius: 5px;
}

.rounded-card {
  border-radius: 35px;
}
</style>
